import { api } from './client.js';

let cachedVapidKey: string | null = null;

export async function getVapidPublicKey(): Promise<string> {
  if (cachedVapidKey) return cachedVapidKey;
  const res = await api<{ vapidPublicKey: string }>('/push/vapid-key', { auth: false });
  cachedVapidKey = res.vapidPublicKey;
  return cachedVapidKey;
}

export async function subscribePush(sub: PushSubscriptionJSON): Promise<void> {
  await api<{ ok: true }>('/push/subscribe', {
    method: 'POST',
    body: JSON.stringify(sub),
  });
}

export async function unsubscribePush(endpoint: string): Promise<void> {
  await api<void>('/push/subscribe', {
    method: 'DELETE',
    body: JSON.stringify({ endpoint }),
  });
}
